// extracted by mini-css-extract-plugin
module.exports = {"page":"_5O1ICbHyA3ebGCIifEllZQ=="};